import styled, { css } from 'styled-components';
import { mediaMaxWidth } from 'common/styles/breakpoints';
import {
    BACKGROUND_PROPERTIES,
    HIGHLIGHT_AND_CONTENT_EDITING_BEHAVIOR_CSS,
} from 'common/components/TouchpointEditor/components/TouchpointContainer';

const SIDE_BY_SIDE_LAYOUT = css`
    min-height: 3.5rem;
    grid-template-columns: 1fr auto 1fr;

    ${mediaMaxWidth.large`
        grid-template-columns: auto minmax(100px, 1fr);
        justify-items: flex-end;
    `}
`;

const STACKED_LAYOUT = css`
    min-height: 6rem;
    grid-template-columns: 1fr;
    justify-items: center;
`;

export const HeaderStyles = styled.header`
    position: sticky;
    top: 0;
    z-index: 1;
    padding: 1rem 2rem;
    display: grid;
    gap: 1rem;
    align-items: center;
    ${(props) => (props.$stacked ? STACKED_LAYOUT : SIDE_BY_SIDE_LAYOUT)}

    ${mediaMaxWidth.large`
        padding: 1rem;
    `}

    ${BACKGROUND_PROPERTIES}
    ${HIGHLIGHT_AND_CONTENT_EDITING_BEHAVIOR_CSS}
`;
